// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","Bronze":"#E8C776","surcharge":"G3e834b","valueBackground":"Gcfc127"};